import type { FC, ReactElement } from 'react';
import type { Offer } from '../../../interfaces';

export type OfferDays = Pick<Offer, 'duration'>;

export const Days: FC<OfferDays> = ({ duration }): ReactElement<OfferDays> | null =>
    duration ? (
        <div className="icon-pre icon--bed u-d1 u-strong" data-testid="offerDuration">
            {`${duration} dager`}
        </div>
    ) : null;
